"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CERNER_EMBEDDED_ORDER_BASED_APPOINTMENT = exports.DIRECT_BOOK_CONTAINER_ID = exports.HEADER_ELEMENT_ID = exports.HIDE_PATIENT_REL_FOR_LOCATIONS = void 0;
exports.HIDE_PATIENT_REL_FOR_LOCATIONS = 'hide_patient_rel_for_locations';
/**
 * Header element ID.
 */
exports.HEADER_ELEMENT_ID = 'dbw-header';
/**
 * Direct book widget Container element ID.
 */
exports.DIRECT_BOOK_CONTAINER_ID = 'dbw-container';
exports.CERNER_EMBEDDED_ORDER_BASED_APPOINTMENT = 'cerner_embedded_order_based_appointment';
//# sourceMappingURL=config.js.map